import $ from "jquery";

// mimics the momentum scrolling of touch devices

let start;

let previous;
let delta;
let totalDelta;
let startScrollTop;
let active;
let options;

const body = $("body");

const setup = (_options) => {
  options = _options;
};

const setStart = (touch) => {
  const x = touch.pageX - body.scrollLeft();
  const y = touch.pageY - body.scrollTop();

  clearTimeout(momentumScrollTimeout);

  start = { x, y };
  delta = {
    x: 0,
    y: 0,
    t: 0,
  };
  previous = {
    x,
    y,
    t: new Date().getTime(),
  };
  totalDelta = {
    x: 0,
    y: 0,
  };
  startScrollTop = options.element.scrollTop();
  active = false;
};

// return value specifies whether we are in vScroll mode
const setMove = (touch) => {
  const x = touch.pageX - body.scrollLeft();
  const y = touch.pageY - body.scrollTop();

  if (!start) {
    return false;
  }
  delta = {
    x: x - previous.x,
    y: y - previous.y,
    t: new Date().getTime() - previous.t,
  };
  previous = {
    x,
    y,
    t: new Date().getTime(),
  };
  totalDelta = {
    x: x - start.x,
    y: y - start.y,
  };
  if (active || (Math.abs(totalDelta.y) > 10 && Math.abs(totalDelta.x) < 6)) {
    // start vScroll!
    active = true;
    options.element.scrollTop(startScrollTop - totalDelta.y);
    return true;
  }
  if (Math.abs(totalDelta.x) > 5) {
    // cancel vScroll
    start = null;
    delta = null;
    totalDelta = null;
    active = false;
  }
  return false;
};

const setEnd = () => {
  if (!active) {
    return false;
  }

  active = false;
  start = null;

  yScrollPosition = options.element.scrollTop();
  yVelocity = delta.y / Math.max(delta.t, 1);

  if (Math.abs(yVelocity) > MAX_VELOCITY) {
    yVelocity = (MAX_VELOCITY * yVelocity) / Math.abs(yVelocity);
  }

  momentumScroll();
  return true;
};

var yScrollPosition;
var yVelocity;
var momentumScrollTimeout;

const // in milliseconds
  TIME_STEP = 30;

var MAX_VELOCITY = 4;

var momentumScroll = () => {
  clearTimeout(momentumScrollTimeout);

  options.element.scrollTop(yScrollPosition);

  const yVelocitySign = yVelocity > 0 ? 1 : -1;

  if (Math.abs(yVelocity) > 0.015) {
    yVelocity = yVelocity * 0.92 - yVelocitySign * 0.015;
    yScrollPosition -= yVelocity * TIME_STEP;
    momentumScrollTimeout = setTimeout(momentumScroll, TIME_STEP);
  }
};

export { setup, setStart, setMove, setEnd };
